import { fetchJson, mutate, qs } from './base-roros.service';
import type { RorosGoalDTO, CreateGoalPayload, UpdateGoalPayload, GoalListMeta } from '@/types/roros/goals';

export const RorosGoalsService = {
  list: async (params?: {
    status?: string;
    domainId?: string;  // A1: camelCase on API surface
    parent_type?: string;
    page?: number;
    pageSize?: number;
  }): Promise<{ data: RorosGoalDTO[]; meta: GoalListMeta }> => {
    const p: Record<string, string> = {};
    if (params?.status) p.status = params.status;
    if (params?.domainId) p.domainId = params.domainId;  // A1
    if (params?.parent_type) p.parent_type = params.parent_type;
    if (params?.page) p.page = String(params.page);
    if (params?.pageSize) p.pageSize = String(params.pageSize);
    return fetchJson<{ data: RorosGoalDTO[]; meta: GoalListMeta }>(`/api/v1/goals${qs(Object.keys(p).length > 0 ? p : undefined)}`);
  },

  getById: (id: string): Promise<RorosGoalDTO> =>
    fetchJson<RorosGoalDTO>(`/api/v1/goals/${id}`),

  create: (payload: CreateGoalPayload): Promise<RorosGoalDTO> =>
    mutate<RorosGoalDTO>('/api/v1/goals', 'POST', payload),

  update: (id: string, payload: UpdateGoalPayload): Promise<RorosGoalDTO> =>
    mutate<RorosGoalDTO>(`/api/v1/goals/${id}`, 'PUT', payload),

  archive: (id: string): Promise<RorosGoalDTO> =>
    mutate<RorosGoalDTO>(`/api/v1/goals/${id}`, 'DELETE'),
};
